import {
    Box,
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import React, {useState} from 'react';
import {Subtitle, H3, H6} from './TypographyShortcuts';
import content from 'components/widgets/tooltips/InfoModalContent';
import InfoModal from 'components/widgets/tooltips/InfoModal';

const MyAccordionSummary = withStyles(theme => ({
    root: {
        borderBottom: '0px',
        margin: '3px',
        paddingTop: '.2rem',
        minHeight: 12,
        '&$expanded': {
            minHeight: 12,
        },
    },
    content: {
        marginBottom: '0px',
        marginTop: '0.2rem',
        '&$expanded': {
            margin: '0',
        },
    },
    expanded: {},
}))(AccordionSummary);

const MyAccordionDetails = withStyles(theme => ({
    root: {
        padding: 0,
    },
}))(AccordionDetails);

const MyAccordion = withStyles(theme => ({
    root: {
        borderRadius: '0 !important',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
    },
    expanded: {},
}))(Accordion);

const useStyles = makeStyles(theme => ({
    root: {
        marginBottom: '.1rem',
        backgroundColor: 'white',
        textAlign: 'center',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    title: {
        textAlign: 'left',
        fontWeight: 'bold',
        [theme.breakpoints.up('sm')]: {
            textAlign: 'center',
        },
    },
    gridWrapper: {
        display: 'flex',
        justifyContent: 'center',
    },
}));

const JumboCard = ({style, children}) => {
    return (
        <Grid item xs={4}>
            <Box style={{...style}}>{children}</Box>
        </Grid>
    );
};

const PrettyFloatDays = ({days = ''}) => {
    if (typeof days === 'number') {
        return days;
    } else {
        const [int, decimal] = days?.split('.');
        return (
            <>
                {int}.
                <Box component='span' fontSize='60%'>
                    {decimal}
                </Box>
            </>
        );
    }
};

const ThreeCard = ({data}) => {
    const specialStyle = {
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
    };
    return (
        <Grid
            container
            item
            direction='column'
            justifyContent='flex-start'
            alignItems='center'
            spacing={0}
        >
            <Grid container>
                <JumboCard>
                    <Subtitle>Total Sea Days</Subtitle>
                </JumboCard>
                <JumboCard style={specialStyle}>
                    <Subtitle>Recency Days (Last 3 Years)</Subtitle>
                </JumboCard>
                <JumboCard>
                    <Subtitle>Renewal Days (Last 5 Years)</Subtitle>
                </JumboCard>
            </Grid>
            <Grid container>
                <JumboCard>
                    <H3>
                        <PrettyFloatDays days={data.credit.total} />
                    </H3>
                </JumboCard>
                <JumboCard style={specialStyle}>
                    <H3>
                        <PrettyFloatDays days={data.credit[3]} />
                    </H3>
                </JumboCard>
                <JumboCard>
                    <H3>
                        <PrettyFloatDays days={data.credit[5]} />
                    </H3>
                </JumboCard>
            </Grid>
        </Grid>
    );
};

const SeaServiceJumbo = ({summary}) => {
    const classes = useStyles();
    const data = summary?.total_days[0];
    const [expanded, setExpanded] = useState(
        window.localStorage.getItem('settings.jumbo') === null
            ? true
            : window.localStorage.getItem('settings.jumbo') === 'true'
    );

    const handleToggleExpand = () => {
        window.localStorage.setItem('settings.jumbo', !expanded);
        setExpanded(!expanded);
    };

    return (
        <Grid container direction='column' className={classes.root}>
            <MyAccordion expanded={expanded} onChange={handleToggleExpand}>
                <MyAccordionSummary
                    className={classes.summary}
                    expandIcon={<ExpandMoreIcon />}
                >
                    <Grid item xs={12} className={classes.gridWrapper}>
                        <H6 className={classes.title}>
                            Sea Service Credit Summary
                        </H6>
                        <InfoModal content={content.seaServiceJumbo} />
                    </Grid>
                </MyAccordionSummary>
                <MyAccordionDetails>
                    {data ? (
                        <ThreeCard data={data} />
                    ) : (
                        <>
                            Something went wrong. Data could not be loaded at
                            this time
                        </>
                    )}
                </MyAccordionDetails>
            </MyAccordion>
        </Grid>
    );
};

export default SeaServiceJumbo;
export {PrettyFloatDays};
